/**
 * Contact page, opening — "Let's build the whole thing": the front scene on
 * paper (lib/scenes.js), `whoami` in a terminal at night. The markup is the
 * server's (templates/site/sections/contact/opening.html.twig).
 *
 * @module sections/contact/opening
 */

import { animateSplitAway } from '../../components/split.js';

export const animate = animateSplitAway;
